export default __webpack_public_path__ + "dcca01f53a8a575d9b34f2a686a3a681.png";